<template>
  <div class="container">
    <div class="el-item__content" @click="OnCli">
      <div class="select-input">
        <span>{{ Tags }}</span>
        <i class="el-icon-postcard"></i>
      </div>
    </div>
    <div class="dialog" v-show="isDialog">
      <div class="dialog-mask">
        <div class="dialog-header">
          <div class="header-main-wrapper">{{ Title }}</div>
          <!-- 搜索栏 -->
          <div>
            <el-autocomplete v-model="state" :fetch-suggestions="querySearch" placeholder="请输入要选择的城市"
              :trigger-on-focus="false" value-key="label" @select="handleSelect"
              style="position: absolute;top:0;left:300px;border: none!important;" prefix-icon="el-icon-search">
            </el-autocomplete>
          </div>
          <!-- 关闭按钮 -->
          <div class="header-modal-close">
            <i class="el-icon-close" @click.prevent="close"></i>
          </div>
        </div>
        <div class="dialog-container">
          <div class="sider">
            <ul>
              <li :class="index === mark ? 'mark' : ''" v-for="(item, index) in Industry" :key="index"
                style="position: relative;" @click="changeSelect(index)" :data-badge="selectNum(item)">{{ item.label }}
              </li>
            </ul>
          </div>
          <div class="content">
            <div class="top">
              <div v-for="(item2, index2) in IndustryDesc" :key="index2" :class="{
                'select_product_no_button': productNoSelects.some(select => select.value === item2.value),
                'product_no_button': !productNoSelects.some(select => select.value === item2.value)
              }" @click="productNoSelect(item2)">
                <span>{{ item2.label }}</span>
              </div>
            </div>
            <div class="buttom">
              <div class="selected">
                <div>已选（{{ length }}/{{ this.Maxlength }}）</div>
                <el-tag closable v-for="(item3, i3) in productNoSelects" :key="i3" @click="delVal(item3)"
                  @close="delVal(item3)">
                  {{ item3.label }}
                </el-tag>

              </div>
              <el-button type="primary" round @click="close">确认</el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    name: {
      type: String,
      default: ''
    },
    oldVal: {
      type: String,
      default: ''
    },
    oldTag: {
      type: String,
      default: ''
    },
    total: {
      type: Number,
      default: 1
    },

  },
  data() {
    return {
      Title: '请选择城市',// 标题
      Tags: "",// 标签的内容
      Values: "",// 行业代码
      isDialog: false,// 是否使用弹窗
      state: '',

      Industry: [
        {
          value: "110000",
          label: "北京",
          children: [{
            label: '北京',
            value: "110100"
          }
          ]
        }, {
          value: "310000",
          label: "上海",
          children: [{
            label: '上海',
            value: "310100"
          }
          ]
        }, {
          value: "120000",
          label: "天津",
          children: [{
            label: '天津',
            value: "120100"
          }
          ]
        }, {
          value: "500000",
          label: "重庆",
          children: [{
            label: '重庆',
            value: "500100"
          }
          ]
        }, {
          value: "",
          label: "港澳台",
          children: [{
            label: '香港',
            value: "810100"
          }, {
            label: '澳门',
            value: "820100"
          }, {
            label: '台湾',
            value: "830100"
          }
          ]
        }, {
          value: "130000",
          label: "河北",
          children: [{
            label: '石家庄',
            value: "130100"
          }, {
            label: '保定',
            value: "130600"
          }, {
            label: '张家口',
            value: "130700"
          }, {
            label: '承德',
            value: "130800"
          }, {
            label: '沧州',
            value: "130900"
          }, {
            label: '唐山',
            value: "130200"
          }, {
            label: '廊坊',
            value: "131000"
          }, {
            label: '衡水',
            value: "131100"
          }, {
            label: '秦皇岛',
            value: "130300"
          }, {
            label: '邯郸',
            value: "130400"
          }, {
            label: '邢台',
            value: "130500"
          }
          ]
        }, {
          value: "140000",
          label: "山西",
          children: [{
            label: '太原',
            value: "140100"
          }, {
            label: '阳泉',
            value: "140300"
          }, {
            label: '长治',
            value: "140400"
          }, {
            label: '晋城',
            value: "140500"
          }, {
            label: '朔州',
            value: "140600"
          }, {
            label: '晋中',
            value: "140700"
          }, {
            label: '运城',
            value: "140800"
          }, {
            label: '忻州',
            value: "140900"
          }, {
            label: '临汾',
            value: "141000"
          }, {
            label: '吕梁',
            value: "141100"
          }, {
            label: '大同',
            value: "140200"
          }
          ]
        }, {
          value: "210000",
          label: "辽宁",
          children: [{
            label: '大连',
            value: "210200"
          }, {
            label: '沈阳',
            value: "210100"
          }, {
            label: '抚顺',
            value: "210400"
          }, {
            label: '本溪',
            value: "210500"
          }, {
            label: '丹东',
            value: "210600"
          }, {
            label: '锦州',
            value: "210700"
          }, {
            label: '营口',
            value: "210800"
          }, {
            label: '阜新',
            value: "210900"
          }, {
            label: '辽阳',
            value: "211000"
          }, {
            label: '盘锦',
            value: "211100"
          }, {
            label: '铁岭',
            value: "211200"
          }, {
            label: '朝阳',
            value: "211300"
          }, {
            label: '葫芦岛',
            value: "211400"
          }, {
            label: '鞍山',
            value: "210300"
          }
          ]
        }, {
          value: "220000",
          label: "吉林",
          children: [{
            label: '长春',
            value: "220100"
          }, {
            label: '白山',
            value: "220600"
          }, {
            label: '松原',
            value: "220700"
          }, {
            label: '白城',
            value: "220800"
          }, {
            label: '延边',
            value: "222400"
          }, {
            label: '吉林市',
            value: "220200"
          }, {
            label: '四平',
            value: "220300"
          }, {
            label: '辽源',
            value: "220400"
          }, {
            label: '通化',
            value: "220500"
          }
          ]
        }, {
          value: "230000",
          label: "黑龙江",
          children: [{
            label: '哈尔滨',
            value: "230100"
          }, {
            label: '佳木斯',
            value: "230800"
          }, {
            label: '七台河',
            value: "230900"
          }, {
            label: '牡丹江',
            value: "231000"
          }, {
            label: '黑河',
            value: "231100"
          }, {
            label: '绥化',
            value: "231200"
          }, {
            label: '大兴安岭',
            value: "232700"
          }, {
            label: '齐齐哈尔',
            value: "230200"
          }, {
            label: '鸡西',
            value: "230300"
          }, {
            label: '鹤岗',
            value: "230400"
          }, {
            label: '双鸭山',
            value: "230500"
          }, {
            label: '大庆',
            value: "230600"
          }, {
            label: '伊春',
            value: "230700"
          }
          ]
        }, {
          value: "320000",
          label: "江苏",
          children: [{
            label: '苏州',
            value: "320500"
          }, {
            label: '南京',
            value: "320100"
          }, {
            label: '淮安',
            value: "320800"
          }, {
            label: '盐城',
            value: "320900"
          }, {
            label: '扬州',
            value: "321000"
          }, {
            label: '镇江',
            value: "321100"
          }, {
            label: '泰州',
            value: "321200"
          }, {
            label: '宿迁',
            value: "321300"
          }, {
            label: '无锡',
            value: "320200"
          }, {
            label: '徐州',
            value: "320300"
          }, {
            label: '常州',
            value: "320400"
          }, {
            label: '南通',
            value: "320600"
          }, {
            label: '连云港',
            value: "320700"
          }
          ]
        }, {
          value: "330000",
          label: "浙江",
          children: [{
            label: '杭州',
            value: "330100"
          }, {
            label: '台州',
            value: "331000"
          }, {
            label: '丽水',
            value: "331100"
          }, {
            label: '宁波',
            value: "330200"
          }, {
            label: '温州',
            value: "330300"
          }, {
            label: '嘉兴',
            value: "330400"
          }, {
            label: '湖州',
            value: "330500"
          }, {
            label: '绍兴',
            value: "330600"
          }, {
            label: '金华',
            value: "330700"
          }, {
            label: '衢州',
            value: "330800"
          }, {
            label: '舟山',
            value: "330900"
          }
          ]
        }, {
          value: "350000",
          label: "福建",
          children: [{
            label: '福州',
            value: "350100"
          }, {
            label: '厦门',
            value: "350200"
          }, {
            label: '莆田',
            value: "350300"
          }, {
            label: '三明',
            value: "350400"
          }, {
            label: '泉州',
            value: "350500"
          }, {
            label: '漳州',
            value: "350600"
          }, {
            label: '南平',
            value: "350700"
          }, {
            label: '龙岩',
            value: "350800"
          }, {
            label: '宁德',
            value: "350900"
          }
          ]
        }, {
          value: "360000",
          label: "江西",
          children: [{
            label: '南昌',
            value: "360100"
          }, {
            label: '萍乡',
            value: "360300"
          }, {
            label: '九江',
            value: "360400"
          }, {
            label: '新余',
            value: "360500"
          }, {
            label: '鹰潭',
            value: "360600"
          }, {
            label: '赣州',
            value: "360700"
          }, {
            label: '吉安',
            value: "360800"
          }, {
            label: '宜春',
            value: "360900"
          }, {
            label: '抚州',
            value: "361000"
          }, {
            label: '上饶',
            value: "361100"
          }, {
            label: '景德镇',
            value: "360200"
          }
          ]
        }, {
          value: "370000",
          label: "山东",
          children: [{
            label: '济南',
            value: "370100"
          }, {
            label: '枣庄',
            value: "370400"
          }, {
            label: '东营',
            value: "370500"
          }, {
            label: '烟台',
            value: "370600"
          }, {
            label: '潍坊',
            value: "370700"
          }, {
            label: '济宁',
            value: "370800"
          }, {
            label: '泰安',
            value: "370900"
          }, {
            label: '威海',
            value: "371000"
          }, {
            label: '日照',
            value: "371100"
          }, {
            label: '临沂',
            value: "371300"
          }, {
            label: '德州',
            value: "371400"
          }, {
            label: '聊城',
            value: "371500"
          }, {
            label: '滨州',
            value: "371600"
          }, {
            label: '青岛',
            value: "370200"
          }, {
            label: '菏泽',
            value: "371700"
          }, {
            label: '淄博',
            value: "370300"
          }
          ]
        }, {
          value: "410000",
          label: "河南",
          children: [{
            label: '郑州',
            value: "410100"
          }, {
            label: '商丘',
            value: "411400"
          }, {
            label: '开封',
            value: "410200"
          }, {
            label: '信阳',
            value: "411500"
          }, {
            label: '洛阳',
            value: "410300"
          }, {
            label: '周口',
            value: "411600"
          }, {
            label: '驻马店',
            value: "411700"
          }, {
            label: '平顶山',
            value: "410400"
          }, {
            label: '济源',
            value: "419001"
          }, {
            label: '安阳',
            value: "410500"
          }, {
            label: '鹤壁',
            value: "410600"
          }, {
            label: '新乡',
            value: "410700"
          }, {
            label: '焦作',
            value: "410800"
          }, {
            label: '濮阳',
            value: "410900"
          }, {
            label: '许昌',
            value: "411000"
          }, {
            label: '漯河',
            value: "411100"
          }, {
            label: '三门峡',
            value: "411200"
          }, {
            label: '南阳',
            value: "411300"
          }
          ]
        }, {
          value: "420000",
          label: "湖北",
          children: [{
            label: '武汉',
            value: "420100"
          }, {
            label: '黄冈',
            value: "421100"
          }, {
            label: '咸宁',
            value: "421200"
          }, {
            label: '随州',
            value: "421300"
          }, {
            label: '恩施州',
            value: "422800"
          }, {
            label: '仙桃',
            value: "429004"
          }, {
            label: '潜江',
            value: "429005"
          }, {
            label: '天门',
            value: "429006"
          }, {
            label: '神农架',
            value: "429021"
          }, {
            label: '黄石',
            value: "420200"
          }, {
            label: '十堰',
            value: "420300"
          }, {
            label: '宜昌',
            value: "420500"
          }, {
            label: '襄阳',
            value: "420600"
          }, {
            label: '鄂州',
            value: "420700"
          }, {
            label: '荆门',
            value: "420800"
          }, {
            label: '孝感',
            value: "420900"
          }, {
            label: '荆州',
            value: "421000"
          }
          ]
        }, {
          value: "430000",
          label: "湖南",
          children: [{
            label: '长沙',
            value: "430100"
          }, {
            label: '永州',
            value: "431100"
          }, {
            label: '怀化',
            value: "431200"
          }, {
            label: '娄底',
            value: "431300"
          }, {
            label: '湘西',
            value: "433100"
          }, {
            label: '株洲',
            value: "430200"
          }, {
            label: '湘潭',
            value: "430300"
          }, {
            label: '衡阳',
            value: "430400"
          }, {
            label: '邵阳',
            value: "430500"
          }, {
            label: '岳阳',
            value: "430600"
          }, {
            label: '常德',
            value: "430700"
          }, {
            label: '张家界',
            value: "430800"
          }, {
            label: '益阳',
            value: "430900"
          }, {
            label: '郴州',
            value: "431000"
          }
          ]
        }, {
          value: "440000",
          label: "广东",
          children: [{
            label: '广州',
            value: "440100"
          }, {
            label: '深圳',
            value: "440300"
          }, {
            label: '惠州',
            value: "441300"
          }, {
            label: '梅州',
            value: "441400"
          }, {
            label: '汕尾',
            value: "441500"
          }, {
            label: '河源',
            value: "441600"
          }, {
            label: '阳江',
            value: "441700"
          }, {
            label: '清远',
            value: "441800"
          }, {
            label: '东莞',
            value: "441900"
          }, {
            label: '韶关',
            value: "440200"
          }, {
            label: '中山',
            value: "442000"
          }, {
            label: '珠海',
            value: "440400"
          }, {
            label: '潮州',
            value: "445100"
          }, {
            label: '揭阳',
            value: "445200"
          }, {
            label: '汕头',
            value: "440500"
          }, {
            label: '云浮',
            value: "445300"
          }, {
            label: '佛山',
            value: "440600"
          }, {
            label: '江门',
            value: "440700"
          }, {
            label: '湛江',
            value: "440800"
          }, {
            label: '茂名',
            value: "440900"
          }, {
            label: '肇庆',
            value: "441200"
          }
          ]
        }, {
          value: "450000",
          label: "广西",
          children: [{
            label: '梧州',
            value: "450400"
          }, {
            label: '北海',
            value: "450500"
          }, {
            label: '防城港',
            value: "450600"
          }, {
            label: '钦州',
            value: "450700"
          }, {
            label: '贵港',
            value: "450800"
          }, {
            label: '玉林',
            value: "450900"
          }, {
            label: '百色',
            value: "451000"
          }, {
            label: '贺州',
            value: "451100"
          }, {
            label: '河池',
            value: "451200"
          }, {
            label: '来宾',
            value: "451300"
          }, {
            label: '崇左',
            value: "451400"
          }, {
            label: '南宁',
            value: "450100"
          }, {
            label: '柳州',
            value: "450200"
          }, {
            label: '桂林',
            value: "450300"
          }
          ]
        }, {
          value: "460000",
          label: "海南",
          children: [{
            label: '海口',
            value: "460100"
          }, {
            label: '三亚',
            value: "460200"
          }, {
            label: '三沙',
            value: "460300"
          }, {
            label: '儋州',
            value: "469003"
          }, {
            label: '五指山',
            value: "469001"
          }, {
            label: '琼海',
            value: "469002"
          }, {
            label: '文昌',
            value: "469005"
          }, {
            label: '万宁',
            value: "469006"
          }, {
            label: '东方',
            value: "469007"
          }, {
            label: '定安县',
            value: "469021"
          }, {
            label: '屯昌县',
            value: "469022"
          }, {
            label: '澄迈县',
            value: "469023"
          }, {
            label: '临高县',
            value: "469024"
          }, {
            label: '白沙县',
            value: "469025"
          }, {
            label: '昌江县',
            value: "469026"
          }, {
            label: '乐东县',
            value: "469027"
          }, {
            label: '陵水县',
            value: "469028"
          }, {
            label: '保亭县',
            value: "469029"
          }, {
            label: '琼中县',
            value: "469030"
          }
          ]
        }, {
          value: "510000",
          label: "四川",
          children: [{
            label: '成都',
            value: "510100"
          }, {
            label: '南充',
            value: "511300"
          }, {
            label: '眉山',
            value: "511400"
          }, {
            label: '宜宾',
            value: "511500"
          }, {
            label: '广安',
            value: "511600"
          }, {
            label: '达州',
            value: "511700"
          }, {
            label: '雅安',
            value: "511800"
          }, {
            label: '巴中',
            value: "511900"
          }, {
            label: '自贡',
            value: "510300"
          }, {
            label: '资阳',
            value: "512000"
          }, {
            label: '阿坝',
            value: "513200"
          }, {
            label: '攀枝花',
            value: "510400"
          }, {
            label: '泸州',
            value: "510500"
          }, {
            label: '甘孜',
            value: "513300"
          }, {
            label: '德阳',
            value: "510600"
          }, {
            label: '绵阳',
            value: "510700"
          }, {
            label: '凉山',
            value: "513400"
          }, {
            label: '广元',
            value: "510800"
          }, {
            label: '遂宁',
            value: "510900"
          }, {
            label: '内江',
            value: "511000"
          }, {
            label: '乐山',
            value: "511100"
          }
          ]
        }, {
          value: "520000",
          label: "贵州",
          children: [{
            label: '贵阳',
            value: "520100"
          }, {
            label: '遵义',
            value: "520300"
          }, {
            label: '安顺',
            value: "520400"
          }, {
            label: '毕节',
            value: "520500"
          }, {
            label: '铜仁',
            value: "520600"
          }, {
            label: '黔西南',
            value: "522300"
          }, {
            label: '黔东南',
            value: "522600"
          }, {
            label: '黔南',
            value: "522700"
          }, {
            label: '六盘水',
            value: "520200"
          }
          ]
        }, {
          value: "530000",
          label: "云南",
          children: [{
            label: '昆明',
            value: "530100"
          }, {
            label: '丽江',
            value: "530700"
          }, {
            label: '普洱',
            value: "530800"
          }, {
            label: '临沧',
            value: "530900"
          }, {
            label: '楚雄州',
            value: "532300"
          }, {
            label: '红河',
            value: "532500"
          }, {
            label: '文山州',
            value: "532600"
          }, {
            label: '西双版纳',
            value: "532800"
          }, {
            label: '大理州',
            value: "532900"
          }, {
            label: '德宏',
            value: "533100"
          }, {
            label: '怒江',
            value: "533300"
          }, {
            label: '迪庆',
            value: "533400"
          }, {
            label: '曲靖',
            value: "530300"
          }, {
            label: '玉溪',
            value: "530400"
          }, {
            label: '保山',
            value: "530500"
          }, {
            label: '昭通',
            value: "530600"
          }
          ]
        }, {
          value: "610000",
          label: "陕西",
          children: [{
            label: '西安',
            value: "610100"
          }, {
            label: '汉中',
            value: "610700"
          }, {
            label: '榆林',
            value: "610800"
          }, {
            label: '安康',
            value: "610900"
          }, {
            label: '商洛',
            value: "611000"
          }, {
            label: '杨陵',
            value: "610403"
          }, {
            label: '铜川',
            value: "610200"
          }, {
            label: '宝鸡',
            value: "610300"
          }, {
            label: '咸阳',
            value: "610400"
          }, {
            label: '渭南',
            value: "610500"
          }, {
            label: '延安',
            value: "610600"
          }
          ]
        }, {
          value: "620000",
          label: "甘肃",
          children: [{
            label: '兰州',
            value: "620100"
          }, {
            label: '临夏',
            value: "622901"
          }, {
            label: '甘南',
            value: "610800"
          }, {
            label: '嘉峪关',
            value: "620200"
          }, {
            label: '金昌',
            value: "620300"
          }, {
            label: '白银',
            value: "620400"
          }, {
            label: '天水',
            value: "620500"
          }, {
            label: '武威',
            value: "620600"
          }, {
            label: '张掖',
            value: "620700"
          }, {
            label: '平凉',
            value: "620800"
          }, {
            label: '酒泉',
            value: "620900"
          }, {
            label: '庆阳',
            value: "621000"
          }, {
            label: '定西',
            value: "621100"
          }, {
            label: '陇南',
            value: "621200"
          }
          ]
        }, {
          value: "630000",
          label: "青海",
          children: [{
            label: '西宁',
            value: "630100"
          }, {
            label: '海东',
            value: "632100"
          }, {
            label: '海北',
            value: "632200"
          }, {
            label: '黄南',
            value: "632300"
          }, {
            label: '海南州',
            value: "632500"
          }, {
            label: '果洛',
            value: "632600"
          }, {
            label: '玉树',
            value: "632700"
          }, {
            label: '海西',
            value: "632800"
          }
          ]
        }, {
          value: "640000",
          label: "宁夏",
          children: [{
            label: '银川',
            value: "640100"
          }, {
            label: '石嘴山',
            value: "640200"
          }, {
            label: '吴忠',
            value: "640300"
          }, {
            label: '固原',
            value: "640400"
          }, {
            label: '中卫',
            value: "640500"
          }
          ]
        }, {
          value: "650000",
          label: "新疆",
          children: [{
            label: '博尔塔拉',
            value: "652700"
          }, {
            label: '巴音郭楞',
            value: "652800"
          }, {
            label: '阿克苏',
            value: "652900"
          }, {
            label: '克州',
            value: "653000"
          }, {
            label: '喀什',
            value: "653100"
          }, {
            label: '和田',
            value: "653200"
          }, {
            label: '伊犁',
            value: "654000"
          }, {
            label: '塔城',
            value: "654200"
          }, {
            label: '阿勒泰',
            value: "654300"
          }, {
            label: '石河子',
            value: "659001"
          }, {
            label: '阿拉尔',
            value: "659002"
          }, {
            label: '图木舒克',
            value: "659003"
          }, {
            label: '五家渠',
            value: "659004"
          }, {
            label: '北屯',
            value: "659005"
          }, {
            label: '铁门关',
            value: "659006"
          }, {
            label: '双河',
            value: "659007"
          }, {
            label: '可克达拉',
            value: "659008"
          }, {
            label: '昆玉',
            value: "659009"
          }, {
            label: '乌鲁木齐',
            value: "650100"
          }, {
            label: '克拉玛依',
            value: "650200"
          }, {
            label: '吐鲁番',
            value: "652100"
          }, {
            label: '哈密',
            value: "652200"
          }, {
            label: '昌吉',
            value: "652301"
          }
          ]
        }, {
          value: "150000",
          label: "内蒙古",
          children: [{
            label: '乌海',
            value: "150300"
          }, {
            label: '赤峰',
            value: "150400"
          }, {
            label: '通辽',
            value: "150500"
          }, {
            label: '鄂尔多斯',
            value: "150600"
          }, {
            label: '呼伦贝尔',
            value: "150700"
          }, {
            label: '巴彦淖尔',
            value: "150800"
          }, {
            label: '乌兰察布',
            value: "150900"
          }, {
            label: '兴安盟',
            value: "152200"
          }, {
            label: '锡盟',
            value: "152500"
          }, {
            label: '阿拉善盟',
            value: "152900"
          }, {
            label: '呼和浩特',
            value: "150100"
          }, {
            label: '包头',
            value: "150200"
          }
          ]
        }
      ],
      IndustryDesc: [],// 二级选择
      mark: 0,// 一级选中的位置
      length: 0,// 当前选中数量
      Maxlength: 1,// 最高选中数量
      waitSelects: [{ value: '9999', label: '不限' }, { value: '110100', label: '北京' }, { value: '320100', label: '南京' }, { value: '330100', label: '杭州' }, { value: '320000', label: '江苏' }, { value: '330000', label: '浙江' }, { value: '310100', label: '上海' }, { value: '440300', label: '深圳' }, { value: '320500', label: '苏州' }],
      productNoSelects: [],
      productNoSelectsSet: new Set(),
      values: ''
    }
  },
  watch: {
    // 监听 productNoSelects 的变化，更新 Set
    productNoSelects: {
      handler(newValue) {
        this.productNoSelectsSet = new Set(newValue.map(item => item.value));
      },
      immediate: true // 组件创建时立即执行一次
    }
  },
  created() {
    this.Maxlength = this.total;
    if (this.oldVal == '') {
      return;
    }
    if (this.name === 'wantDqs') {
      const values = this.oldVal.split(',');
      const tags = this.oldTag.split('，');
      // 创建对象数组
      this.productNoSelects = values.map((value, index) => {
        return {
          label: tags[index],
          value: value
        };
      });
      this.length = tags.length;
      this.Values = this.oldVal;
      this.Tags = this.oldTag;
    } else {
      this.Values = this.oldVal;
      this.Tags = this.oldTag;
      if (this.Values !== '') {
        this.length = 1;
      } else {
        this.length = 0;
      }
      this.productNoSelects[0] = { "label": this.Tags, "value": this.Values };
    }

  },
  methods: {
    selectNum(item) {
      let num = 0;
      for (const child of item.children) {
        if (this.productNoSelectsSet.has(child.value)) {
          num++;
        }
      }
      return num;
    },
    querySearch(queryString, cb) {
      var restaurants = this.restaurants;
      var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    createFilter(queryString) {
      return (restaurant) => {
        return (restaurant.label.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
      };
    },
    getAllArea() {
      var allAreas = []
      this.Industry.forEach((item, index) => {
        if (index != 0) {
          allAreas = [...allAreas, ...item.children]
        }
      })
      this.restaurants = allAreas
    },
    touchmove() {
      // 防止默认行为的事件处理函数
      var preventDefaultHandler = function (event) {
        // 检查 event 是否为有效的事件对象
        if (event && typeof event.preventDefault === 'function') {
          event.preventDefault();
        }
      };
      document.body.style.overflow = 'hidden';
      document.addEventListener("touchmove", preventDefaultHandler, false);//禁止页面滑动
    },
    OnCli() {
      if (this.productNoSelects.length === 1 && this.productNoSelects[0].label === '不限') {
        this.productNoSelects = [];
      }
      this.isDialog = true;
      this.touchmove();
    },
    close() {
      this.waitSelects = this.waitSelects.filter(waitItem =>
        !this.productNoSelects.some(selectItem => selectItem.value === waitItem.value)
      );
      this.waitSelects = [...this.waitSelects, ...this.productNoSelects];
      this.Values = this.productNoSelects.map(item => item.value).join(","); // 返回地址代码
      this.Tags = this.productNoSelects.map(item => item.label).join("，"); // 显示标签文本

      if (this.name === 'wantDqs') {
        this.$emit("changeWantDqs", this.Values); // 返回完整数据
      } else {
        this.$emit("changeNowDqs", this.Values); // 返回完整数据
      }
      this.isDialog = false;
      document.body.style.overflow = '';
    },
    changeSelect(index) {
      this.mark = index;
      this.IndustryDesc = this.Industry[index].children;
    },
    productNoSelect(val) {
      if (val.label === '不限') {
        this.productNoSelects = [{ value: '9999', label: '不限' }];
        this.length = 0;
        return;
      }
      if (this.productNoSelects.length > 0) {
        if (this.productNoSelects.length === 1 && this.productNoSelects[0].label === '不限') {
          this.productNoSelects = [];
        }
      }
      // 判断当前选项是否已被选中
      const index = this.productNoSelects.findIndex(item => item.value === val.value);
      if (index !== -1) {
        this.productNoSelects.splice(index, 1);
        this.length -= 1;
      } else if (this.length < this.Maxlength) {
        this.productNoSelects.push(val);
        this.length += 1;
      }
      this.Values = this.productNoSelects.map(item => item.value).join("，"); // 显示标签文本
      if (this.name === 'wantDqs') {
        this.$emit("changeWantDqs", this.Values); // 返回完整数据
      } else {
        this.$emit("changeNowDqs", this.Values); // 返回完整数据
      }
    },
    delVal(val) {
      // 如果已选中，移除该项
      const index = this.productNoSelects.findIndex(item => item.value === val.value);
      if (index !== -1) {
        this.productNoSelects.splice(index, 1);
        this.length -= 1;
      }
    },
    handleSelect(item) {
      this.productNoSelect(item)
      this.state = ''
    }
  },
  mounted() {
    // this.restaurants = this.loadAll();
    this.getAllArea()
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-input__inner {
  border: none !important;
  background-color: #f5f5f5;
  transition: all .2s;
  height: 35px;
}

::v-deep .el-input__inner:hover {
  box-shadow: inset 0 0 0 1px #ccc;
  transition: all .2s;
}

::v-deep .el-input__inner:focus {
  background-color: #fff;
  box-shadow: inset 0 0 0 1px #ccc;
  transition: all .2s;
}



.inline-input {
  border: none !important;
  outline: none !important;
}

.el-item__content {
  line-height: 40px;
  position: relative;
  font-size: 14px;
  width: 100%;

  .select-input {
    display: flex;
    align-items: center;
    width: 100%; // 220px
    height: 32px;
    padding: 10px 32px 10px 15px;
    box-sizing: border-box;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    background-color: #fff;
    cursor: pointer;
    position: relative;

    span {
      width: 238px;
      height: 40px;
      white-space: nowrap;
      /* 禁止换行 */
      overflow: hidden;
      /* 超出隐藏 */
      text-overflow: ellipsis;
      /* 溢出显示省略号 */
    }

    i {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      right: 6px;
      font-size: 24px;
      color: #c2c6d4;
    }
  }
}

// 遮罩板块
.dialog {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1000;
  height: 100%;
  background-color: rgba(0, 0, 0, .45);
  overflow: hidden;
  box-sizing: border-box;

  .dialog-mask {
    position: relative;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 788px;
    height: 488px;
    background-color: #FFF;
    border-radius: 8px;

    .dialog-header {
      height: 50px;
      line-height: 50px;
      padding-left: 24px;
      display: flex;
      align-items: center;
      border-bottom: 1px solid #e6eaf1;
      border-radius: 8px 8px 0 0;
      background: #fff;
      color: #333;
      position: relative;
      font-size: 16px;
      word-wrap: break-word;

      .header-main-wrapper {
        display: inline-block;
        font-weight: 600;
        width: 199px;
        min-width: 199px;
        margin-right: 25px;
        color: #000;
      }

      .header-modal-close {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        right: 20px;
        width: 30px;
        height: 30px;
        font-size: 20px;
        font-weight: bold;
        align-items: center;
        line-height: 30px;
        text-align: center;
        cursor: pointer;
        justify-content: center;
      }

      .header-modal-close:hover {
        background-color: #dfe0e0;
        border-radius: 20px;
      }
    }

    .dialog-container {
      display: flex;
      justify-items: center;
      height: calc(100% - 50px);
      overflow: hidden;

      .sider {
        width: 180px;
        height: 100%;
        box-sizing: border-box;
        font-size: 14px;
        overflow: hidden;

        ul {
          position: relative;
          width: 180px;
          height: 100%;
          padding: 10px 10px;
          overflow-y: scroll;
          overflow-x: hidden;
          border-right: 10px solid #e6eaf1;
          color: #222;
          box-sizing: border-box;

          /* 设置溢出内容时显示滚动条 */
          /* 滚动条样式 */
          &::-webkit-scrollbar {
            width: 3px !important;
            /* 滚动条宽度 */
          }

          &::-webkit-scrollbar-track {
            background: none;
            /* 轨道颜色 */
          }

          &::-webkit-scrollbar-thumb {
            background: #dce0e6;
            /* 滑块颜色 */
            border-radius: 10px;
            /* 滑块圆角 */

          }

          &::-webkit-scrollbar-thumb:hover {
            background: #dce0e6;
            /* 鼠标悬停时滑块颜色 */
          }

          li {
            width: 100%;
            border-radius: 8px;
            padding-left: 12px !important;
            margin-bottom: 6px;
            line-height: 22px;
            padding: 10px 10px;
            box-sizing: border-box;
            cursor: pointer;
          }

          li:hover {
            background: #f3f3f3;
          }

          li[data-badge]:not([data-badge="0"])::after {
            content: attr(data-badge);
            text-align: center;
            color: #fff;
            font-size: 10px;
            position: absolute;
            right: 10px;
            top: 10px;
            width: 20px;
            height: 20px;
            background: red;
            opacity: 1;
            border-radius: 50%;
          }

          .mark {
            width: 100%;
            background: #f3f3f3;
            color: #000;
            font-weight: bold;
          }
        }
      }

      .content {
        height: 100%;
        padding: 24px 0 0 32px;
        width: calc(100% - 180px);
        position: relative;
        overflow: hidden;

        .top {
          display: flex;
          flex-wrap: wrap;
          overflow-y: scroll;
          max-height: 460px;
          font-size: 16px;

          /* 设置溢出内容时显示滚动条 */
          /* 滚动条样式 */
          &::-webkit-scrollbar {
            width: 3px !important;
            /* 滚动条宽度 */
          }

          &::-webkit-scrollbar-track {
            background: none;
            /* 轨道颜色 */
          }

          &::-webkit-scrollbar-thumb {
            background: #dce0e6;
            /* 滑块颜色 */
            border-radius: 10px;
            /* 滑块圆角 */
          }

          &::-webkit-scrollbar-thumb:hover {
            background: #dce0e6;
            /* 鼠标悬停时滑块颜色 */
          }

          .product_no_button {
            width: fit-content;
            height: fit-content;
            margin-right: 10px;
            margin-bottom: 15px;
            padding: 10px 20px;
            border: 1px solid #f8f9fb;
            background-color: #f8f9fb;
            cursor: pointer;
            display: inline-block;
            text-align: center;
            border-radius: 8px;
            user-select: none;
          }

          .select_product_no_button {
            width: fit-content;
            height: fit-content;
            margin-right: 10px;
            margin-bottom: 15px;
            padding: 10px 20px;
            border: 1px solid #409EFF;
            background-color: #f8f9fb;
            color: #409EFF;
            cursor: pointer;
            display: inline-block;
            text-align: center;
            border-radius: 8px;
            user-select: none;
          }
        }

        .buttom {
          position: absolute;
          bottom: 30px;
          width: calc(100% - 64px);
          font-size: 14px;
          background: #fff;
          display: flex;
          justify-content: space-between;
          justify-items: center;
          align-items: center;

          .selected {
            display: flex;
            height: 50px;
            line-height: 50px;
            align-items: center;

            .el-tag {
              margin-right: 10px;
              cursor: pointer;
            }
          }
        }
      }
    }
  }

  .mark {
    background: #f3f3f3;
    color: #000;
  }
}
</style>